<script>
    import { navigateTo } from 'svelte-router-spa'
    import { visitPurpose } from '../../../store.js'

    function nxt(myPurpose) {
        visitPurpose.set(myPurpose)
        if (myPurpose === 'PERSONAL') {
            navigateTo('symptom')
        } else if (myPurpose === 'OFFICIAL') {
            navigateTo('VisitCompany')
        } else {
            alert("Error. Please try again.")
        }
    }
</script>

<main>
    <div class="body">
        <h1>What is the nature of your visit?</h1>
        <a class="btn" on:click={() => nxt('OFFICIAL')}>
            <span class="e">Official</span>
        </a>
        <a class="btn" on:click={() => nxt('PERSONAL')}>
            <span class="e">Personal</span>
        </a>
    </div>
</main>